import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import {
  NegotiationCaseCreateWizardState,
  toDemandRequestInputMapper,
} from '../components/NegotiationCaseCreateWizard/NegotiationCaseCreateWizard.schema';
import { CallbackResult } from '~/components/WizardState/hooks/useWizardFormControls/useWizardFormControls';

import { SAVE_DEMAND_REQUEST_MUTATION } from './SaveDemandRequest.mutation.gql';

export const useSaveDemandRequest = () => {
  const [saveDemandRequest] = useMutation(SAVE_DEMAND_REQUEST_MUTATION);

  return useCallback(
    async (state: NegotiationCaseCreateWizardState): Promise<CallbackResult> => {
      const { success: isSafeParsed, data: inputData, error } = toDemandRequestInputMapper.safeParse(state);

      if (isSafeParsed) {
        const { errors } = await saveDemandRequest({ variables: inputData });
        return { success: !errors, error: errors };
      }
      return { success: false, error };
    },
    [saveDemandRequest],
  );
};
